import useWebChatAPIContext from '/druid/useWebChatAPIContext';

export default function useSetDictateState() {
  return useWebChatAPIContext().setDictateState;
}
